import { motion } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { useBag } from "../../context/BagContext";

const scrollTo = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};

const LINKS = [
  { label: "Shop", target: "essentials", id: "shop" },
  { label: "Hair Care", target: "shop", id: "hair" },
  { label: "Body Care", target: "body-care", id: "body" },
  { label: "Ingredients", target: "ingredients", id: "ingredients" },
  { label: "FAQ", target: "faq", id: "faq" },
];

export const Navbar = () => {
  const { quantity, setOpen } = useBag();

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#F8F4EC]/85 border-b border-[rgba(58,42,37,0.08)]"
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="h-16 flex items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-serif-display text-2xl tracking-[0.25em] text-[#3A2A25] font-medium"
          data-testid="nav-brand-logo"
        >
          CELUSTA
        </button>
        <nav className="hidden sm:flex gap-7 text-xs font-mono-accent uppercase tracking-[0.18em] text-[#756A64]">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.target)}
              className="gold-underline hover:text-[#3A2A25] transition-colors duration-300"
              data-testid={`nav-${l.id}-link`}
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <button
            onClick={() => scrollTo("essentials")}
            className="hidden sm:block px-5 py-2 bg-[#3A2A25] text-white text-[11px] font-semibold uppercase tracking-[0.15em] rounded-full hover:bg-[#55423A] transition-colors duration-300"
            data-testid="nav-shop-now-button"
          >
            Shop Now
          </button>
          <button
            onClick={() => setOpen(true)}
            className="relative p-2 text-[#3A2A25] hover:text-[#C9A45C] transition-colors duration-300"
            data-testid="nav-bag-button"
          >
            <ShoppingBag size={20} strokeWidth={1.5} />
            {quantity > 0 && (
              <span className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-[#C9A45C] text-white text-[10px] font-semibold flex items-center justify-center" data-testid="bag-count-badge">
                {quantity}
              </span>
            )}
          </button>
        </div>
        </div>
        <nav className="sm:hidden flex gap-6 pb-3 overflow-x-auto text-[11px] font-mono-accent uppercase tracking-[0.15em] text-[#756A64]" data-testid="mobile-nav-links">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.target)}
              className="whitespace-nowrap"
              data-testid={`mobile-nav-${l.id}-link`}
            >
              {l.label}
            </button>
          ))}
        </nav>
      </div>
    </motion.header>
  );
};
